import { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import ChaveIntegracao from "../../components/Configuracoes/ChaveIntegracao/ChaveIntegracao";
import { Compartilhamento } from "../../components/Configuracoes/Compartilhamento/Compartilhamento";
import { ConfigCorreios } from "../../components/Configuracoes/ConfigCorreios/ConfigCorreios";
import Endereco from "../../components/Configuracoes/Endereco/Endereco";
import EntregaLocal from "../../components/Configuracoes/EntregaLocal/EntregaLocal";
import FreteEspecialMain from "../../components/Configuracoes/FreteEspecialMain/FreteEspecialMain";
import FreteGratisMain from "../../components/Configuracoes/FreteGratisMain/FreteGratisMain";
import InformacoesDaMarca from "../../components/Configuracoes/InformacoesDaMarca/InformacoesDaMarca";
import IntegracaoBling from "../../components/Configuracoes/IntegracaoBling/IntegracaoBling";
import IntegracaoBlingV2 from "../../components/Configuracoes/IntegracaoBlingV2/IntegracaoBlingV2";
import IntegracaoTiny from "../../components/Configuracoes/IntegracaoTiny/IntegracaoTiny";
import { Dropshipping } from "../../components/Configuracoes/Dropshipping/Dropshipping";
import MelhorEnvio from "../../components/Configuracoes/MelhorEnvio/MelhorEnvio";
import PagamentoCombinar from "../../components/Configuracoes/PagamentoCombinar/PagamentoCombinar";
import { Pedido } from "../../components/Configuracoes/Pedido/Pedido";
import { PoliticaDePrivacidade } from "../../components/Configuracoes/PoliticaDePrivacidade/PoliticaDePrivacidade";
import { PoliticaDeTrocaeDevolucao } from "../../components/Configuracoes/PoliticaDeTrocaeDevolucao/PoliticaDeTrocaeDevolucao";
import { PoliticaDeFrete } from "../../components/Configuracoes/PoliticaDeFrete/PoliticaDeFrete";
import RetiradaNoLocal from "../../components/Configuracoes/RetiradaNoLocal/RetiradaNoLocal";
import VisualMain from "../../components/Configuracoes/VisualMain/VisualMain";
import { ConfiguracoesContext } from "../../contexts/Configuracoes/ConfiguracoesContext";
import { IntegracaoContext } from "../../contexts/Integracao/IntegracaoContext";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { EmpresaApi } from "../../hooks/empresaApi";
import { dropshippingApi, DropshippingConfiguracao } from "../../hooks/dropshippingApi";
import CuponsMain from "../../components/Configuracoes/cuponsMain/CuponsMain";
import BrindesMain from "../../components/Configuracoes/brindesMain/BrindesMain";
import { FacebookPixel } from "../../components/Configuracoes/FacebookPixel/FacebookPixel";
import { PinterestTag } from "../../components/Configuracoes/PinterestTag/PinterestTag";
import { VerificacoesDeDominio } from "../../components/Configuracoes/VerificacoesDeDominio/VerificacoesDeDominio";
import { Google } from "../../components/Configuracoes/Google/Google";
import { Recaptcha } from "../../components/Configuracoes/Recaptcha/Recaptcha";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import PagamentoPagSeguro from "../../components/Configuracoes/PagamentoPagSeguro/PagamentoPagSeguro";
import PagamentoPagarme from "../../components/Configuracoes/PagamentoPagarme/PagamentoPagarme";
import PagamentoPagarmeHub from "../../components/Configuracoes/PagamentoPagarmeHub/PagamentoPagarmeHub";
import PagamentoMercadoPago from "../../components/Configuracoes/PagamentoMercadoPago/PagamentoMercadoPago";
import Mensageria from "../../components/Configuracoes/Mensageria/Mensageria";

interface ComponentItem {
  component: () => JSX.Element;
  title?: string;
  subtitle?: string;
  permitido?: boolean;
  value?: boolean;
  dropdown?: boolean;
  bloqueado_mensagem?: string;
  somente_leitura?: boolean; // abre pelo "Configurar", mas sem editar
  visivel?: boolean; // nova propriedade para controlar visibilidade
  onChange?: (newValue: boolean) => void | boolean; //on change pro toogle que ativa o dropdown
}

const isBlingV2 = (configuracoes) => {
  return (
    configuracoes.dados_bling_v2 !== undefined ||
    (!configuracoes.dados_bling === undefined &&
      configuracoes.dados_bling_v2 === undefined)
  );
};

export const useComponentMapping = () => {

  const { permissoesPlanos } = useContext(AuthContext);
  const { loading } = useContext(ConfiguracoesContext);
  const { empresa } = useContext(EmpresaContext);

  // Usuarios com acesso a mensageria (remover quando liberar pra todos)
  const MENSAGERIA_USUARIOS_LIBERADOS = ['lerinV3', 'Amifluffy'];
  const mensageriaLiberada = MENSAGERIA_USUARIOS_LIBERADOS.includes(empresa?.usuario || '');

  const isSuporte = empresa?.usuario === 'atendimento_conecta';

  const {
    chaveIntegracao,
    setChaveIntegracao,
    activeChaveIntegracao,
    onChangeIntegracao,
    onChangeIntegracaoBling,
    onChangeIntegracaoTiny,
    onChangeIntegracaoBlingV2,
  } = useContext(IntegracaoContext);
  const { theme } = useTheme();
  // Sem flag no banco: toggle ligado se a conta tem chave ou vínculo.
  const dropshippingPermitido =
    permissoesPlanos["DROPSHIPPING_CONTA_MAE"]?.permitido ||
    permissoesPlanos["DROPSHIPPING_CONTA_SATELITE"]?.permitido;
  const [dropshippingAtivo, setDropshippingAtivo] = useState(false);
  const [dropshippingEmUso, setDropshippingEmUso] = useState(false);
  // DROPSHIPPING PROVISÓRIO: revendedor com chave ativa
  const [dropshippingRevendedorAtivo, setDropshippingRevendedorAtivo] = useState(false);

  // Também chamado pelo card do Dropshipping ao vincular/remover, para travar sem recarregar a página.
  const aplicarConfigDropshipping = (config: DropshippingConfiguracao) => {
    // Vínculo encerrado: toggle aparece ligado (card "Desconectado"), mas pode ser desligado
    const emUso = !!(config.mae?.chaves.length || config.satelite?.vinculo?.ativo);
    setDropshippingEmUso(emUso);
    if (emUso || config.satelite?.vinculo) setDropshippingAtivo(true);
    setDropshippingRevendedorAtivo(!!config.satelite?.vinculo?.ativo);
  };

  useEffect(() => {
    if (!dropshippingPermitido) return;
    dropshippingApi()
      .configuracao()
      .then(aplicarConfigDropshipping)
      .catch((error) => console.log(error));
  }, [dropshippingPermitido]);

  const onChangeDropshipping = (newValue: boolean) => {
    if (!dropshippingPermitido) return;
    if (!newValue && dropshippingEmUso) {
      Swal.fire({
        text: "O Dropshipping está em uso nesta conta. Para encerrar, remova as chaves na configuração.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return false;
    }
    setDropshippingAtivo(newValue);
  };

  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
  useEffect(() => {
    setConfiguracoes({
      ...configuracoes,
      pagarmeAtivo: configuracoes.pagarmeAtivo ?? false,
      pagBankAtivo: configuracoes.pagBankAtivo ?? false,
      pagarmehubAtivo: configuracoes.pagarmehubAtivo ?? false,
      mercadoPagoAtivo: configuracoes.mercadoPagoAtivo ?? false,
      cuponsAtivo: configuracoes.cuponsAtivo ?? false,
      brindesAtivo: configuracoes.brindesAtivo ?? false,
    });
  }, []);

  // Funções de validação para exclusão mútua entre métodos de pagamento
  const onChangePagarme = (newValue: boolean) => {
    if (newValue) {
      const { pagarmehub, mercadopago, pagseguro, ...restIntermediadores } = configuracoes.intermediadores;
      setConfiguracoes({
        ...configuracoes,
        pagarmeAtivo: true,
        pagBankAtivo: false,
        pagarmehubAtivo: false,
        mercadoPagoAtivo: false,
        intermediadores: {
          ...restIntermediadores,
          pagarme: configuracoes.intermediadores.pagarme,
        }
      });
    } else {
      setConfiguracoes({
        ...configuracoes,
        pagarmeAtivo: false,
      });
    }
  };

  const onChangePagarmehub = (newValue: boolean) => {
    if (newValue) {
      const { pagarme, mercadopago, pagseguro, ...restIntermediadores } = configuracoes.intermediadores;
      setConfiguracoes({
        ...configuracoes,
        pagarmehubAtivo: true,
        pagarmeAtivo: false,
        pagBankAtivo: false,
        mercadoPagoAtivo: false,
        intermediadores: {
          ...restIntermediadores,
          pagarmehub: configuracoes.intermediadores.pagarmehub,
        }
      });
    } else {
      setConfiguracoes({
        ...configuracoes,
        pagarmehubAtivo: false,
      });
    }
  };

  const onChangePagBank = (newValue: boolean) => {
    if (newValue) {
      const { pagarme, pagarmehub, mercadopago, ...restIntermediadores } = configuracoes.intermediadores;
      setConfiguracoes({
        ...configuracoes,
        pagBankAtivo: true,
        pagarmeAtivo: false,
        pagarmehubAtivo: false,
        mercadoPagoAtivo: false,
        intermediadores: {
          ...restIntermediadores,
          pagseguro: configuracoes.intermediadores.pagseguro,
        }
      });
    } else {
      setConfiguracoes({
        ...configuracoes,
        pagBankAtivo: false,
      });
    }
  };

  const onChangeMercadoPago = (newValue: boolean) => {
    if (newValue) {
      const { pagarme, pagarmehub, pagseguro, ...restIntermediadores } = configuracoes.intermediadores;
      setConfiguracoes({
        ...configuracoes,
        mercadoPagoAtivo: true,
        pagarmeAtivo: false,
        pagarmehubAtivo: false,
        pagBankAtivo: false,
        intermediadores: {
          ...restIntermediadores,
          mercadopago: configuracoes.intermediadores.mercadopago,
        }
      });
    } else {
      setConfiguracoes({
        ...configuracoes,
        mercadoPagoAtivo: false,
      });
    }
  };

  const componentMapping: { [key: string]: ComponentItem } = {
    informacoesdamarca: {
      component: () => <InformacoesDaMarca configIn="configuracoes" />,
    },
    endereco: {
      component: () => <Endereco configIn="configuracoes" />,
    },
    correios: {
      component: () => <ConfigCorreios configIn="configuracoes" />,
      title: "Correios",
      dropdown: true,
      permitido: permissoesPlanos["INTEGRACAO_COM_OS_CORREIOS"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      subtitle: "Entrega e Retirada",
      value: configuracoes.frete.correiosAtivo || false,
      onChange: (newValue) => {
        if (!permissoesPlanos["INTEGRACAO_COM_OS_CORREIOS"]?.permitido )
          return;
        setConfiguracoes({
          ...configuracoes,
          frete: {
            ...configuracoes.frete,
            correiosAtivo: newValue,
          },
        });
      },
    },
    melhorenvio: {
      component: () => <MelhorEnvio />,
      title: "Melhor Envio",
      subtitle: "Entrega e Retirada",
      dropdown: true,
      permitido: permissoesPlanos["FRETE_MELHOR_ENVIO"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      value: configuracoes.frete.melhorEnvio.ativo,
      onChange: (newValue) => {
        if (!permissoesPlanos["FRETE_MELHOR_ENVIO"]?.permitido ) return;
        setConfiguracoes({
          ...configuracoes,
          frete: {
            ...configuracoes.frete,
            melhorEnvio: {
              ...configuracoes.frete.melhorEnvio,
              ativo: newValue,
            },
          },
        });
      },
    },
    entregalocal: {
      component: () => <EntregaLocal configIn="configuracoes" />,
      title: "Entrega local",
      dropdown: true,
      permitido: permissoesPlanos["RETIRADA_LOCAL"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      subtitle: "Entrega e Retirada",
      value: configuracoes.frete.entregaLocal.ativo || false,
      onChange: (newValue) => {
        if (!permissoesPlanos["RETIRADA_LOCAL"]?.permitido ) return;
        setConfiguracoes({
          ...configuracoes,
          frete: {
            ...configuracoes.frete,
            entregaLocal: {
              ...configuracoes.frete.entregaLocal,
              ativo: newValue,
            },
          },
        });
      },
    },
    entregaespecial: {
      component: () => <FreteEspecialMain configIn="configuracoes" />,
      title: "Entrega especial",
      subtitle: "Entrega e Retirada",
      dropdown: true,
      permitido: permissoesPlanos["ENTREGA_ESPECIAL"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      value: configuracoes.frete.freteEspecialAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["ENTREGA_ESPECIAL"]?.permitido ) return;
        setConfiguracoes({
          ...configuracoes,
          frete: {
            ...configuracoes.frete,
            freteEspecialAtivo: newValue,
          },
        });
      },
    },
    cupons: {
      component: () => <CuponsMain />,
      permitido: permissoesPlanos["CUPOM_DE_DESCONTO"]?.permitido,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      title: "Cupons",
      subtitle: "Promoções",
      dropdown: true,
      value: configuracoes.cuponsAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["CUPOM_DE_DESCONTO"]?.permitido) return;
        setConfiguracoes({
          ...configuracoes,
          cuponsAtivo: newValue,
        });
      },
    },
    brindes: {
      component: () => <BrindesMain />,
      permitido: permissoesPlanos["BRINDES"]?.permitido,
      bloqueado_mensagem: "Recurso disponível a partir do plano Avançado.",
      title: "Brindes",
      subtitle: "Promoções",
      dropdown: true,
      value: configuracoes.brindesAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["BRINDES"]?.permitido) return;
        setConfiguracoes({
          ...configuracoes,
          brindesAtivo: newValue,
        });
      },
    },
    fretegratis: {
      component: () => <FreteGratisMain />,
      title: "Frete grátis",
      subtitle: "Promoções",
      dropdown: true,
      permitido: permissoesPlanos["FRETE_GRATIS"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      value: configuracoes.frete.freteGratisAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["FRETE_GRATIS"]?.permitido ) return;
        setConfiguracoes({
          ...configuracoes,
          frete: {
            ...configuracoes.frete,
            freteGratisAtivo: newValue,
          },
        });
      },
    },
    retiradanolocal: {
      component: () => <RetiradaNoLocal configIn="configuracoes" />,
      title: "Retirada no local",
      subtitle: "Entrega e Retirada",
      dropdown: true,
      permitido: permissoesPlanos["RETIRADA_LOCAL"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      value: configuracoes.frete.retirada_no_local.ativo,
      onChange: (newValue) => {
        if (!permissoesPlanos["RETIRADA_LOCAL"]?.permitido ) return;
        setConfiguracoes({
          ...configuracoes,
          frete: {
            ...configuracoes.frete,
            retirada_no_local: {
              ...configuracoes.frete.retirada_no_local,
              ativo: newValue,
            },
          },
        });
      },
    },

    pagarme: {
      component: () => <PagamentoPagarme configIn="configuracoes" />,
      title: "Stone (API)",
      subtitle: "Pagamento",
      dropdown: true,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      permitido: permissoesPlanos["PAGAMENTO_ONLINE_PAGARME_E_PAGSEGURO"]?.permitido,
      visivel: (() => {
        const isActive = !loading && configuracoes?.pagarmeAtivo;
        return isActive;
      })(),
      value: configuracoes.pagarmeAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["PAGAMENTO_ONLINE_PAGARME_E_PAGSEGURO"]?.permitido) return;
        return onChangePagarme(newValue);
      },
    },
    
    pagarmehub: {
      component: () => <PagamentoPagarmeHub configIn="configuracoes" />,
      title: "Stone",
      subtitle: "Pagamento",
      dropdown: true,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      permitido: permissoesPlanos["PAGAMENTO_ONLINE_PAGARME_E_PAGSEGURO"]?.permitido,
      value: configuracoes.pagarmehubAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["PAGAMENTO_ONLINE_PAGARME_E_PAGSEGURO"]?.permitido) return;
        return onChangePagarmehub(newValue);
      },
    },

    pagbank: {
      component: () => <PagamentoPagSeguro configIn="configuracoes" />,
      title: "PagBank",
      subtitle: "Pagamento",
      dropdown: true,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      permitido: permissoesPlanos["PAGAMENTO_ONLINE_PAGARME_E_PAGSEGURO"]?.permitido,
      value: configuracoes.pagBankAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["PAGAMENTO_ONLINE_PAGARME_E_PAGSEGURO"]?.permitido) return;
        return onChangePagBank(newValue);
      },
    },
    
    mercadopago: {
      component: () => <PagamentoMercadoPago configIn="configuracoes" />,
      title: "Mercado Pago",
      subtitle: "Pagamento",
      dropdown: true,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      permitido: permissoesPlanos["PAGAMENTO_MERCADO_PAGO"]?.permitido,
      value: configuracoes.mercadoPagoAtivo,
      onChange: (newValue) => {
        if (!permissoesPlanos["PAGAMENTO_MERCADO_PAGO"]?.permitido) return;
        return onChangeMercadoPago(newValue);
      },
    },
    whatsapp: {
      component: () => <Mensageria />,
      title: "WhatsApp",
      subtitle: "Comunicação",
      dropdown: true,
      permitido: permissoesPlanos["WHATSAPP"]?.permitido,
      bloqueado_mensagem: "Recurso disponível a partir do plano Avançado.",
      visivel: mensageriaLiberada,
      value: configuracoes.comunicacao?.whatsapp?.ativo || false,
      onChange: (newValue: boolean) => {
        if (!permissoesPlanos["WHATSAPP"]?.permitido) return;
        setConfiguracoes({
          ...configuracoes,
          comunicacao: {
            ...configuracoes.comunicacao,
            whatsapp: {
              ...configuracoes.comunicacao?.whatsapp,
              ativo: newValue,
            },
          },
        });
      },
    },
    pagamentoacombinar: {
      component: () => <PagamentoCombinar configIn="configuracoes" />,
      title: "Pagamento a combinar",
      dropdown: true,
      permitido: true,
      subtitle: "Pagamento",
      value: configuracoes.pagamentoCombinarAtivo,
      onChange: (newValue) => {
        // Se tentar desativar e nenhum outro método estiver ativo ele bloqueia e mostra o modal
        if (
          newValue === false &&
          !configuracoes.mercadoPagoAtivo &&
          !configuracoes.pagarmeAtivo &&
          !configuracoes.pagarmehubAtivo &&
          !configuracoes.pagBankAtivo
        ) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção',
            text: 'Você não pode desativar o pagamento "A Combinar" sem ativar outro método de pagamento.',
          });
          return;
        }
        setConfiguracoes({
          ...configuracoes,
          pagamentoCombinarAtivo: newValue,
          intermediadores: {
            ...configuracoes.intermediadores,
            a_combinar: {
              ...configuracoes.intermediadores?.a_combinar,
              ativo: newValue,
            },
          },
        });
      },
    },
    pedido: {
      component: () => <Pedido configIn="configuracoes" />,
      title: "Pedido",
      permitido: true,
      subtitle: "Configure seu catálogo",
    },
    politicadeprivacidade: {
      component: () => <PoliticaDePrivacidade configIn="configuracoes" />,
      title: "Política de privacidade",
      permitido: true,
      subtitle: "Configure seu catálogo",
    },
    politicadetrocaedevolucao: {
      component: () => <PoliticaDeTrocaeDevolucao configIn="configuracoes" />,
      title: "Política de troca e devolução",
      permitido: true,
      subtitle: "Configure seu catálogo",
    },
    politicadefrete: {
      component: () => <PoliticaDeFrete configIn="configuracoes" />,
      title: "Política de frete",
      permitido: true,
      subtitle: "Configure seu catálogo",
    },
    compartilhamento: {
      component: () => <Compartilhamento configIn="configuracoes" />,
      title: "Compartilhamento",
      permitido: true,
      subtitle: "Configure seu catálogo",
    },
    visual: {
      component: () => <VisualMain />,
      title: "Visual",
      permitido: true,
      subtitle: "Configure seu catálogo",
    },
    chaveintegracao: {
      component: () => (
        <ChaveIntegracao
          chave={chaveIntegracao}
          setChaveDeIntegracao={setChaveIntegracao}
        />
      ),
      title: "Chave de API",
      dropdown: true,
      permitido: permissoesPlanos["CHAVE_DE_API"]?.permitido ,
      bloqueado_mensagem: "Recurso disponível no plano Avançado",
      subtitle: "Integrações",
      value: activeChaveIntegracao,
      onChange: (newValue) => {
        if (!permissoesPlanos["CHAVE_DE_API"]?.permitido) return;
        return onChangeIntegracao(newValue);
      },
    },
    integracaodobling: {
      component: () =>
        isBlingV2(configuracoes) ? <IntegracaoBlingV2 /> : <IntegracaoBling />,
      title: "Bling",
      dropdown: true,
      permitido:
        permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      subtitle: "Integrações",
      value: isBlingV2(configuracoes)
        ? configuracoes.dados_bling_v2!.ativo
        : configuracoes.dados_bling.ativo,
      onChange: (newValue) => {
        if (!permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido) return;
        if (isBlingV2(configuracoes)) {
          return onChangeIntegracaoBlingV2(newValue);
        } else {
          return onChangeIntegracaoBling(newValue);
        }
      },
    },
    integracaodatiny: {
      component: () => <IntegracaoTiny />,
      title: "Olist",
      dropdown: true,
      permitido:
        permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      subtitle: "Integrações",
      value: configuracoes.dados_tiny_v2.ativo,
      onChange: (newValue) => {
        if (!permissoesPlanos["INTEGRACAO_COM_ERP_BLING_E_TINY"]?.permitido) return;
        return onChangeIntegracaoTiny(newValue);
      },
    },
    dropshipping: {
      component: () => <Dropshipping onCarregar={aplicarConfigDropshipping} />,
      title: "Dropshipping",
      dropdown: true,
      permitido: dropshippingPermitido,
      bloqueado_mensagem: "Recurso disponível a partir do plano Essencial.",
      subtitle: "Integrações",
      value: dropshippingAtivo,
      onChange: onChangeDropshipping,
    },
    verificacoesdedominio: {
      component: () => <VerificacoesDeDominio />,
      title: "Verificações de domínio",
      dropdown: true,
      permitido:
        permissoesPlanos["VERIFICACAO_DE_DOMINIO_ATRELADO_A_DOMINIO"]
          ?.permitido ,
      bloqueado_mensagem: "Recurso disponível no plano Avançado",
      value: configuracoes.verificacoes_de_dominio.ativo,
      subtitle: "Integrações",
      onChange: (newValue) => {
        if (
          !permissoesPlanos["VERIFICACAO_DE_DOMINIO_ATRELADO_A_DOMINIO"]
            ?.permitido 
        )
          return;
        setConfiguracoes({
          ...configuracoes,
          verificacoes_de_dominio: {
            ...configuracoes.verificacoes_de_dominio,
            ativo: newValue,
          },
        });
      },
    },
    facebookpixel: {
      component: () => <FacebookPixel />,
      title: "Meta",
      dropdown: true,
      permitido:
        permissoesPlanos["PIXEL_DO_FACEBOOK_ATRELADO_A_VERIFICACAO_DO_DOMINIO"]?.permitido,
      bloqueado_mensagem: "Recurso disponível no plano Avançado",
      subtitle: "Integrações",
      value: configuracoes.dados_facebook_pixel.ativo,
      onChange: (newValue) => {
        if (
          !permissoesPlanos["PIXEL_DO_FACEBOOK_ATRELADO_A_VERIFICACAO_DO_DOMINIO"]?.permitido
        )
          return;
        if (!isSuporte) return;
        setConfiguracoes({
          ...configuracoes,
          dados_facebook_pixel: {
            ...configuracoes.dados_facebook_pixel,
            ativo: newValue,
          },
        });
      },
    },
    pinterest: {
      component: () => <PinterestTag />,
      title: "Pinterest",
      dropdown: true,
      permitido:
        permissoesPlanos["ID_DO_PINTEREST"]?.permitido,
      bloqueado_mensagem: "Recurso disponível no plano Avançado",
      subtitle: "Integrações",
      value: configuracoes.dados_pinterest?.ativo || false,
      onChange: (newValue) => {
        if (
          !permissoesPlanos["ID_DO_PINTEREST"]?.permitido
        )
          return;
        setConfiguracoes({
          ...configuracoes,
          dados_pinterest: {
            ...configuracoes.dados_pinterest,
            ativo: newValue,
          },
        });
      },
    },
    google: {
      component: () => <Google />,
      title: "Google",
      dropdown: true,
      permitido: permissoesPlanos["INTEGRACAO_COM_GOOGLE_ANALYTICS"]?.permitido,
      bloqueado_mensagem: "Recurso disponível no plano Avançado",
      subtitle: "Integrações",
      value: configuracoes.dados_google.ativo,
      onChange: (newValue) => {
        if (!permissoesPlanos["INTEGRACAO_COM_GOOGLE_ANALYTICS"]?.permitido) return;
        setConfiguracoes({
          ...configuracoes,
          dados_google: {
            ...configuracoes.dados_google,
            ativo: newValue,
          },
        });
      },
    },
    recaptcha: {
      component: () => <Recaptcha />,
      title: "reCAPTCHA",
      dropdown: true,
      permitido: true,
      subtitle: "Integrações",
      value: configuracoes.dados_recaptcha?.ativo || false,
      onChange: (newValue) => {
        setConfiguracoes({
          ...configuracoes,
          dados_recaptcha: {
            ...configuracoes.dados_recaptcha,
            ativo: newValue,
          },
        });
      },
    },
  };
  // DROPSHIPPING PROVISÓRIO: pagamento e entrega vêm da mãe, então ficam travados.
  if (dropshippingRevendedorAtivo) {
    [
      "correios", "melhorenvio", "entregalocal", "entregaespecial", "retiradanolocal", "fretegratis",
      "pagarme", "pagarmehub", "pagbank", "mercadopago", "pagamentoacombinar",
    ].forEach((id) => {
      componentMapping[id] = {
        ...componentMapping[id],
        permitido: false,
        bloqueado_mensagem: "Recurso indisponível em conta com Dropshipping ativo",
        somente_leitura: true,
      };
    });
    // Gateways cuidam da própria leitura: abrem cartão/pix para ver, sem editar
    ["pagarme", "pagarmehub", "pagbank", "mercadopago"].forEach((id) => {
      componentMapping[id].somente_leitura = false;
    });
    componentMapping.pagarme.component = () => <PagamentoPagarme configIn="configuracoes" somenteLeitura />;
    componentMapping.pagarmehub.component = () => <PagamentoPagarmeHub configIn="configuracoes" somenteLeitura />;
    componentMapping.pagbank.component = () => <PagamentoPagSeguro configIn="configuracoes" somenteLeitura />;
    componentMapping.mercadopago.component = () => <PagamentoMercadoPago configIn="configuracoes" somenteLeitura />;
  }

  // Revendedor com chave ativa não usa ERP, Chave de API nem Brindes
  if (dropshippingRevendedorAtivo) {
    ["integracaodobling", "integracaodatiny", "chaveintegracao", "brindes"].forEach((id) => {
      componentMapping[id] = {
        ...componentMapping[id],
        permitido: false,
        bloqueado_mensagem: "Recurso indisponível em conta com Dropshipping ativo",
        somente_leitura: true,
      };
    });
  }

  return componentMapping;
};
